import styled from "styled-components";
import bg from './assets/pull-vault-app-panel.png';

export const PanelContainer = styled.div`
    border-radius: 16px;
    box-shadow: inset 0 0 0 4px rgba(0,0,0,0.4);
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
    position: relative;
    transition: box-shadow 0.5s;
    width: 100%;

    &:hover {
        box-shadow: inset 0 0 0 12px rgba(0,0,0,0.4);
    }
`

export const BlurOverlay = styled.div`
    backdrop-filter: blur(8px);
    background: rgba(0,0,0,0.1);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
`

export const BgImage = styled.div`
    background-image: url(${bg});
    background-size: cover;
    background-position: center;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
`

export const InfoContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    z-index: 2;
`

export const Title = styled.h3`
    color: #FFFFFF;
    font-size: 16px;
`

export const ReleaseDateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 6px;
`

export const ReleaseDate = styled.h4`
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 400;
`

export const Moon = styled.div`
    border: 2px solid #FFFFFF;
    border-radius: 12px;
    height: 8px;
    width: 8px;
`
